import { TreoLocation } from "graphql/types"

// Maximum number of subchapters allowed
// If more chapters are allowed, the query GET_REPORT_BY_ID must also have more subchapters in the fragment ChapterFields.
export const maxSubChapterLevel = 4

export const unitList = [
  { value: "K", label: "K (Kelvin)" },
  { value: "K/min", label: "K/min (Kelvin pro Minute)" },
  { value: "°C", label: "°C (Grad Celsius)" },
  { value: "mV", label: "mV (Millivolt)" },
  { value: "V", label: "V (Volt)" },
  { value: "kV", label: "kV (Kilovolt)" },
  { value: "Hz", label: "Hz (Hertz)" },
  { value: "kHz", label: "kHz (Kilohertz)" },
  { value: "Mhz", label: "MHz (Megahertz)" },
  { value: "GHz", label: "GHz (Gigahertz)" },
  { value: "mg", label: "mg (Milligramm)" },
  { value: "g", label: "g (Gramm)" },
  { value: "kg", label: "kg (Kilogramm)" },
  { value: "mm", label: "mm (Millimeter)" },
  { value: "cm", label: "cm (Zentimeter)" },
  { value: "m", label: "m (Meter)" },
  { value: "ml", label: "ml (Milliliter)" },
  { value: "l", label: "l (Liter)" },
  { value: "s", label: "s (Sekunden)" },
  { value: "min", label: "min (Minuten)" },
  { value: "h", label: "h (Stunden)" },
  { value: "d", label: "d (Tage)" },
  { value: "A", label: "A (Ampere)" },
  { value: "mA", label: "mA (Milliampere)" },
  { value: "V (AC)", label: "V (AC) (Wechselspannung)" },
  { value: "V (DC)", label: "V (DC) (Gleichspannung)" },
]

export const contactTypes = [
  "Projektleitung",
  "Technischer Kontakt",
  "Einkauf",
  "Endkunde",
  "Witnessing",
]

export const treoLocationList: TreoLocation[] = [
  { name: "Hamburg", costCenter: "20", abbreviation: "TESTSHH" },
  { name: "Neumünster", costCenter: "30", abbreviation: "TESTSNMS" },
  { name: "Hamburg (extern)", costCenter: "10", abbreviation: "EXTERNHH" },
  { name: "Neumünster (extern)", costCenter: "20", abbreviation: "EXTERNNMS" },
]

export const branchList = [
  "Allgemeine Industrie",
  "Bahntechnik",
  "Fahrrad & E-Bike",
  "Fahrzeugbau",
  "Luftfahrt",
  "Medizintechnik",
  "Militär",
  "Raumfahrt",
  "Schiffbau",
  "Solarenergie",
  "Windenergie",
]

// Utility function to convert unitList to strings for AutocompleteMulti compatibility
export const getUnitListForAutocomplete = () => {
  return unitList.map((unit) => (typeof unit === "string" ? unit : unit.label))
}

// Utility function to convert selected labels back to values
export const convertLabelsToValues = (labels: string[]) => {
  return labels.map((label) => {
    const unit = unitList.find((u) => (typeof u === "string" ? u === label : u.label === label))
    return typeof unit === "string" ? unit : unit?.value || label
  })
}

// Utility function to convert values to labels for display
export const convertValuesToLabels = (values: string[]) => {
  return values.map((value) => {
    const unit = unitList.find((u) => (typeof u === "string" ? u === value : u.value === value))
    return typeof unit === "string" ? unit : unit?.label || value
  })
}
